import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import categoryReducer from "./slices/category";
import statReducer from "./slices/stats";
import desiginationReducer from "./slices/desigination";
import venueUserReducer from "./slices/venueUser";
import warehouseUserReducer from "./slices/warehouseUser";
import venueReducer from "./slices/venue";
import customer from "./slices/customer";
import stockSlice from "./slices/stock";
import ingredientReducer from "./slices/ingredient";
import adjustmentSlice from "./slices/adjustment";
import itemReducer from "./slices/item";
import gallery from "./slices/gallery";
import purchaseOrderSlice from "./slices/purchaseOrder";
import invoiceSlice from "./slices/invoice"
import SupplierSlice from "./slices/supplier";
import accountsPurchasedOrderSlice from "./slices/accountsPurchasedOrder";
import accountsGoodReceiptNoteSlice from "./slices/accountsGoodReceiptNote";
import accountsApInvoiceSlice from "./slices/accountsApInvoice";
import accountsBankingSlice from "./slices/accountsBanking";
import accountsBankingReturnSlice from "./slices/accountsBankingReturn";
import accountsAdvancePaymentSlice from "./slices/accountsAdvancePayment";
import accountsAdvancePaymentReturnSlice from "./slices/accountsAdvancePaymentReturn";
import accountsPurchaseOrderReturnSlice from "./slices/accountsPurchaseOrderReturn";
import accountsGoodReceiptNoteReturnSlice from "./slices/accountsGoodReceiptNoteReturn";
import accountsApInvoiceReturnSlice from "./slices/accountsApInvoiceReturn";
import stockRequestSlice from "./slices/stockRequest";
import stockTransferSlice from "./slices/stockTransfer";
import stockReturnSlice from "./slices/stockReturn";
import inventorySlice from "./slices/inventory";

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const cateogoryPersistConfig = {
  key: "category",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const statPersistConfig = {
  key: "stat",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const desiginationPersistConfig = {
  key: "desigination",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const venueUserPersistConfig = {
  key: "venueUser",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const warehouseUserPersistConfig = {
  key: "warehouseUser",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const venuePersistConfig = {
  key: "venue",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const supplierPersistConfig = {
  key: "supplier",
  storage,
  keyPrefix: "redux-",
  whitelist: ["suppliers"],
};

const rootReducer = combineReducers({
  category: persistReducer(cateogoryPersistConfig, categoryReducer),
  stat: persistReducer(statPersistConfig, statReducer),
  desigination: persistReducer(desiginationPersistConfig, desiginationReducer),
  venueUser: persistReducer(venueUserPersistConfig, venueUserReducer),
  warehouseUser: persistReducer(warehouseUserPersistConfig, warehouseUserReducer),
  venue: persistReducer(venuePersistConfig, venueReducer),
  customer: customer,
  stockSlice: stockSlice,
  ingredient: ingredientReducer,
  adjustmentSlice: adjustmentSlice,
  item: itemReducer,
  gallery: gallery,
  purchaseOrderSlice: purchaseOrderSlice,
  accountsPurchasedOrder: accountsPurchasedOrderSlice,
  accountsGoodReceiptNote: accountsGoodReceiptNoteSlice,
  accountsApInvoice: accountsApInvoiceSlice,
  accountsBanking: accountsBankingSlice,
  accountsBankingReturn: accountsBankingReturnSlice,
  accountsAdvancePayment: accountsAdvancePaymentSlice,
  accountsAdvancePaymentReturn: accountsAdvancePaymentReturnSlice,
  accountsPurchaseOrderReturn: accountsPurchaseOrderReturnSlice,
  accountsGoodReceiptNoteReturn: accountsGoodReceiptNoteReturnSlice,
  accountsApInvoiceReturn: accountsApInvoiceReturnSlice,
  stockRequest: stockRequestSlice,
  stockTransfer: stockTransferSlice,
  stockReturn: stockReturnSlice,
  inventory: inventorySlice,
  invoiceSlice: invoiceSlice,
  supplier: persistReducer(supplierPersistConfig, SupplierSlice),
});

export default rootReducer;
